import { FC } from 'react'
import { IoMdArrowBack } from 'react-icons/io'
import { IoSunny } from 'react-icons/io5'
import CustomText from '../../CustomText'
import HeadingView from '../HeadingView/HeadingView'
import BackButton from '../BackButton/BackButton'
import InfoView from '../InfoView/InfoView'
import CheckListItem from '../ChecklistItem/CheckListItem'
import { PiHouse } from 'react-icons/pi'
import { Flex, Text, Button } from '@chakra-ui/react'
import { UserProperty } from '../../../generated/graphql'
import { capitalizeFirstLetter } from '../../../helpers'

type PropertyCardDuexProps = {
  isLoadingEmailButton: boolean
  active: boolean
  property: UserProperty
  handleClick: () => void
  handlSendEmail?: () => void
  showResendEmailButton: boolean
}

export const PropertyCardDuex: FC<PropertyCardDuexProps> = ({
  isLoadingEmailButton = false,
  handlSendEmail,
  active,
  handleClick,
  property,
  showResendEmailButton = false
}: PropertyCardDuexProps) => {
  return (
    <Flex
      direction={'column'}
      gap="10px"
      w={'grow'}
      h={'grow'}
      className="border-solid border-[1px] border-[#000000] rounded-[22px] p-[16px]"
    >
      <Text fontSize={'14px'} color={'brand.text.primary'}>
        <b>Type:</b>{' '}
        {capitalizeFirstLetter(
          property?.subscription?.subscriptionOption?.replace('2023_', '') as string
        )}{' '}
        subscription
      </Text>
      <Text fontSize={'14px'} color={'brand.text.primary'}>
        <b>Address:</b>
      </Text>
      <Text fontSize={'14px'} color={'brand.text.primary'}>
        {property?.fullAddress}
      </Text>
      <Text fontSize={'14px'} color={'brand.text.primary'}>
        <b>Order status:</b> {property?.orderStatus?.replace(' (incomplete)', '')}
      </Text>
      <Text fontSize={'14px'} color={'brand.text.primary'}>
        <b>Installation date:</b>{' '}
        {property?.installationDate ? property?.installationDate : 'Not set'}
      </Text>
      <Text fontSize={'14px'} color={'brand.text.primary'}>
        <b>Entity type:</b> {property?.entityType}
      </Text>

      <div className="w-full grow flex flex-col justify-end gap-y-[10px]">
        {active && showResendEmailButton && (
          <Button
            variant={'dark'}
            isLoading={isLoadingEmailButton}
            onClick={handlSendEmail}
            type="submit"
            mt="15px"
            className="cursor-pointer active:scale-[1.02] hover:scale-[1.04]"
          >
            Resend to agent only
          </Button>
        )}
        {active && (
          <BackButton label="Continue home transfer" handleClick={handleClick} isBack={false}>
            <></>
          </BackButton>
        )}

        {!active && (
          <Button
            variant={'dark'}
            isLoading={false}
            onClick={handleClick}
            type="submit"
            mt="15px"
            className="cursor-pointer active:scale-[1.02] hover:scale-[1.04]"
          >
            Begin process
          </Button>
        )}
      </div>
    </Flex>
  )
}

export default PropertyCardDuex
